import BaseService from "../BaseService";
import http from "../HttpService";
import { API_BASE_URL_ENV } from "helpers/common";

const apiEndpoint = API_BASE_URL_ENV() + "/site/search";
const apiPopulerDataEndpoint = API_BASE_URL_ENV() + "/site";
const apiCompareEndpoint = API_BASE_URL_ENV() + "/site/compare";
const apiRangeFilter = API_BASE_URL_ENV() + "/site/search-specifications";
const apiDeveloperCompoundFilter =
	API_BASE_URL_ENV() + "/site/developer-compound-search";
const apiDeveloperCompoundSerch =
	API_BASE_URL_ENV() + "/site/developer-compounds";
const apiResaleFilter =
	API_BASE_URL_ENV() + "/site/search-suggestions?type=resale";
const apiCurrencies = API_BASE_URL_ENV() + "/common/get-currencies";
const apiDefaultCurrency = API_BASE_URL_ENV() + "/common/set-default-currency";
const apiDefaultUserCurrency =
	API_BASE_URL_ENV() + "/website/user/update-default-currency";
const apiUserCurrencies = API_BASE_URL_ENV() + "/common/user-currency";
const apiUserLocationCurrencies =
	API_BASE_URL_ENV() + "/common/user-location-currency";

export default class extends BaseService {
	constructor() {
		super(apiEndpoint);
	}

	getPopulerData = () => {
		return http.get(apiPopulerDataEndpoint);
	};

	getDeveloperCompoundData = (data) => {
		return http.get(`${apiDeveloperCompoundFilter}?keyword=${data}`);
	};

	getDeveloperCompounds(params) {
		return http.get(apiDeveloperCompoundSerch, { params });
	}

	getResaleData = (data) => {
		return http.get(`${apiResaleFilter}&keyword=${data}`);
	};

	getComparedCompound = (params) => {
		return http.get(apiCompareEndpoint, { params });
	};

	getRangeFilter = (params = { type: "unit" }) => {
		return http.get(apiRangeFilter, { params });
	};

	getCurrencies = () => {
		return http.get(apiCurrencies);
	};

	getUserCurrency = () => {
		return http.get(apiUserCurrencies);
	};

	getUserLocationCurrency = () => {
		return http.get(apiUserLocationCurrencies);
	};

	setCurrency = (data) => {
		return http.post(apiDefaultCurrency, data);
	};

	setUserCurrency = (data) => {
		return http.post(apiDefaultUserCurrency, data);
	};
}
